import React from 'react';
var defaultValue = [undefined, function () {}];
var TaskItemsFormatContext = /*#__PURE__*/React.createContext(defaultValue);
var reducer = function reducer(_state, action) {
  return action;
};
export function TaskItemsFormatProvider(_ref) {
  var children = _ref.children;
  var value = React.useReducer(reducer, undefined);
  return /*#__PURE__*/React.createElement(TaskItemsFormatContext.Provider, {
    value: value
  }, children);
}
export function useTaskItemsFormatContext() {
  return React.useContext(TaskItemsFormatContext);
}
export function TaskItemsFormatConsumer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(TaskItemsFormatContext.Consumer, null, children);
}